// Handlers bound DIRECTLY to elements rather than delegated through $(document).on().
//
// Two different reasons, only one of which is historical:
//
// 1. getDirectionsForm (submit) was direct-bound because old MyCars called stopPropagation(),
//    which killed delegated handlers. Old MyCars is now disabled fleet-wide — the
//    mycarsEnabled preference appears in only 3 of 10,813 production site configs
//    (hertzprofile, hertzgroupprofile25, hdemogroupprofile25) and is `false` in all three.
//    So that reason no longer applies and the entry can move to getDocumentOnHandlers.
// 2. The video entries MUST stay here. Media events (play, pause, timeupdate, ended) do NOT
//    bubble, and jQuery delegation depends on bubbling. Verified in a real browser with this
//    repo's jQuery: play.bubbles === false, $(document).on('play','video',h) never fires, and
//    $('video').on('play',h) does. Moving them would silently kill ALL video tracking.
//    (A native addEventListener(..., true) capture-phase listener CAN see them, but that is a
//    separate change with different ordering semantics — see the note on the play handlers.)

/*
	This section is for handling:
	$(selectors[selector]).on(events,handler);
*/
const getSelectorOnHandlers = ({ link, video }) => [
	{
		// US358331: handle ws-contact 'get directions' button as a get directions link event
		// TODO: This can probably go in getDocumentOnHandlers but we should test
		// Perhaps it was set up like this due to some OSIRIS thing or something.
		// Maybe the eventDelegation won't work. Not sure.
		event: 'submit',
		selector: 'getDirectionsForm',
		handler: link.getDirections
	},
	// These video events CANNOT go in getDocumentOnHandlers — media events do not bubble, so
	// jQuery delegation never sees them. Proven in a real browser, not assumed.
	// ORDERING IS LOAD-BEARING: two handlers bind 'play'. video.play handles the first play;
	// video.resume handles every subsequent one. Reordering them swaps those semantics.
	{
		// Fires when play is clicked on HTML5 video
		event: 'play',
		selector: 'video',
		handler: video.play
	},
	{
		// Every subsequent play (resume after pause); the first play is video.play
		event: 'play',
		selector: 'video',
		handler: video.resume
	},
	{
		// Fires when the user pauses HTML5 video
		event: 'pause',
		selector: 'video',
		handler: video.pause
	},
	{
		event: 'timeupdate',
		selector: 'video',
		handler: video.milestones.track
	},
	{
		event: 'ended',
		selector: 'video',
		handler: video.milestones.complete
	}
];

export default getSelectorOnHandlers;
